import { render, staticRenderFns } from "./PainelGrupoAtalho.vue?vue&type=template&id=fbee6328&scoped=true"
import script from "./PainelGrupoAtalho.vue?vue&type=script&lang=js"
export * from "./PainelGrupoAtalho.vue?vue&type=script&lang=js"
import style0 from "./PainelGrupoAtalho.vue?vue&type=style&index=0&id=fbee6328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbee6328",
  null
  
)

export default component.exports